import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
import { CRM_PIPELINE_API } from '../api/crm-pipeline-api';
import { CrmPipelineApiInterface } from '../types/pipeline-interface';
interface CrmPipelineListProps extends SwrPaginationInterface {}
export function useCrmPipelineList(t0) {
  const $ = _c(13);
  const {
    pagination,
    limit
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== limit || $[2] !== pagination || $[3] !== user) {
    t2 = () => {
      if (user) {
        return `${CRM_PIPELINE_API}?${getPaginationQueryString({
          limit,
          pagination
        })}`;
      }
      return null;
    };
    $[1] = limit;
    $[2] = pagination;
    $[3] = user;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: crmPipelineList,
    mutate
  } = useSWR(t2, fetcher);
  let t3;
  if ($[5] !== limit || $[6] !== pagination || $[7] !== user) {
    t3 = () => {
      if (user) {
        return `${CRM_PIPELINE_API}/count?${getPaginationQueryString({
          limit,
          pagination
        })}`;
      }
      return null;
    };
    $[5] = limit;
    $[6] = pagination;
    $[7] = user;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    data: counter
  } = useSWR(t3, baseFetcher);
  let t4;
  if ($[9] !== counter || $[10] !== crmPipelineList || $[11] !== mutate) {
    t4 = {
      crmPipelineList,
      mutate,
      counter
    };
    $[9] = counter;
    $[10] = crmPipelineList;
    $[11] = mutate;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}